export interface SnackbarData {
  message: string;
  type?: SnackbarType;
}

export enum SnackbarType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  DEFAULT = 'default',
};
